// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class AlertNotesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Creates a new alert note for a metric alert.
     *
     * @param alertId: Alert ID.
     * @param objectType: The underlying object type of the alert.
     * @param noteContent: Note's text content.
     */
    createNote(id, noteText, type) {
        return this.ajaxService.postFormEncodedDataObserveBody(this.urlsService.ALERTS.ALERT_NOTE_COLLECTION, {
            noteContent: noteText,
            alertId: id,
            objectType: type,
        });
    }
    /**
     * Deletes an AlertNote with the given ID.
     *
     * @param alertNoteId: AlertNote ID.
     */
    deleteNote(id) {
        const deleteUrl = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_NOTE, { id });
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    /**
     * Gets AlertNotes with the given alert ID.
     *
     * @param alertNoteId: AlertNote ID.
     */
    getNotes(id) {
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_NOTE, { id });
        return this.ajaxService.getDataObserveBody(url);
    }
}
AlertNotesService.ɵfac = function AlertNotesService_Factory(t) { return new (t || AlertNotesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AlertNotesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AlertNotesService, factory: AlertNotesService.ɵfac, providedIn: 'root' });
